module.exports = __webpack_public_path__ + "static/media/7.d2355c29.jpg";